import React from 'react';

import {translate} from 'iss/strings';
import {PlainRestResultMessage} from 'iss/widgets/MessageBox';
import {FormList} from 'iss/widgets/FormList';

export function BatchOpFailure({message, extraColumns = [], operationResult}) {
  const forms = operationResult.failed.map(({form, ...rest}) => ({...rest, ...form}));

  return <React.Fragment>
    <p>{translate(message, {count: operationResult.failed.length})}</p>
    <FormList compact={true} forms={forms} extraColumns={[
      ...extraColumns,
      {
        header: translate('questionOperations.error'),
        accessor: ({result}) => <React.Fragment>
          <div style={{color: "red"}}><PlainRestResultMessage result={result} /></div>
        </React.Fragment>
      }
    ]} />
</React.Fragment>;
}

export function listFailuresWithMessage(message) {
  return (props) => <BatchOpFailure message={message} {...props} />;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/evaluationForm/BatchOpFailure.jsx